import icon from 'vue-svgicon';

icon.register({
    'bold/multiple-neutral-2': {
        width: 16,
        height: 16,
        viewBox: '0 0 24 24',
        data: `<path pid="0" d="M18 14.5a5.95 5.95 0 0 0-2.619.608.5.5 0 0 0-.206.711A8.934 8.934 0 0 1 16.5 20.5a.5.5 0 0 0 .5.5h6.5a.5.5 0 0 0 .5-.5 6 6 0 0 0-6-6z"/><circle pid="1" cx="17.944" cy="10.25" r="3.75"/><circle pid="2" cx="7.5" cy="7.75" r="4.75"/><path pid="3" d="M15 20.5a7.5 7.5 0 0 0-15 0 .5.5 0 0 0 .5.5h14a.5.5 0 0 0 .5-.5z"/>`,
    },
});
